import { Link, useMatch } from 'react-router-dom'
import { Fragment, useContext, useEffect, useState } from 'react';
import henceforthApi, { Redirect_Seller_URL } from '../../utils/henceforthApi';
import { sellerdetails } from '../../context/interfaces';
import ProductListingDetails from './SellerProductListing';
import { GlobalContext, handleError } from '../../context/Provider';
import { toast } from 'react-toastify'
import Spinner from '../../components/BootstrapCompo';
import SellerOrderListing from './SellerOrderListing';
import Swal from 'sweetalert2';
import profile_placeholder from '../../assets/images/pages/profile_placeholder.png'
import SignedImage from '../../components/SignedImage';
import StoreList from './StoreList';

const ViewSeller = () => {

    const { authState } = useContext(GlobalContext);
    const match: any = useMatch("/seller/:id")
    const [loading, setloading] = useState(false)
    const [loader, setloader] = useState(false)
    const [loader1, setloader1] = useState(false)
    const [commissionLoading, setCommissionLoading] = useState(false)
    const [commission, setCommission] = useState<number | string>('')
    const [currentCommission, setCurrentCommission] = useState<number | null>(null)
    const [selectedImage, setSelectedImage] = useState<string | null>(null)


    const [state, setState] = useState<sellerdetails>()


    const onChnageDelete = async () => {
        // setloading(true)
        Swal.fire({
            title: "Are you sure?",
            text: "Are you sure want to delete this seller!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                try {
                    let apires = await henceforthApi.Seller.sellerdelete(match?.params?.id)
                    toast.success(apires?.data?.message)
                    window.history.back()
                } catch (error) {
                    handleError(error)
                } finally {
                    setloading(false)
                }
            }
        })
    }
    const sellerdetails = async () => {
        try {
            let Apies = await henceforthApi.Seller.details(match?.params?.id)
            setState(Apies)
            fetchSellerCommission()
        } catch (error) {

        } finally {

        }
    }

    const fetchSellerCommission = async () => {
        try {
            const response = await henceforthApi.Seller.getSellerCommission(match?.params?.id)
            if (response) {
                setCurrentCommission(response?.data?.seller?.commission)
                setCommission(response?.data?.seller?.commission)
            }
        } catch (error) {
            // Commission might not exist yet, that's okay
            console.log('No existing commission found')
        }
    }

    const handleCommissionSubmit = async (e: React.FormEvent) => {
        e.preventDefault()

        if (!commission || commission === '') {
            toast.error('Please enter a commission value')
            return
        }

        setCommissionLoading(true)
        try {
            const response = await henceforthApi.Seller.setSellerCommission(
                match?.params?.id,
                Number(commission)
            )
            toast.success('Commission updated successfully')
            setCurrentCommission(Number(commission))
        } catch (error) {
            handleError(error)
        } finally {
            setCommissionLoading(false)
        }
    }

    const onChangeActiveDeactive = async () => {
        // Swal.fire({
        //     title: "Are you sure?",
        //     text: `Are you sure want to ${ state?.data.account_status == "activated" ? `deactivated` : `activated`} this seller!`,
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     cancelButtonColor: "#d33",
        //     confirmButtonText: `Yes, ${ state?.data.account_status == "activate" ? `deactivate` : `activate`} it!`,
        // })
        // setloader1(true)
        // const data = {
        //     type: "ACTIVATE/DEACTIVATE",
        //     _id: state?.data._id,
        //     account_status: state?.data.account_status == "ACTIVATED" ? `DEACTIVATED` : `ACTIVATED`,
        // }
        // try {
        //     let apires = await henceforthApi.Seller.manageSeller(data)
        //     toast.success(apires.data.message)
        //     sellerdetails()
        // } catch (error) {
        //     handleError(error)
        // } finally {
        //     setloader1(false)
        // }
        Swal.fire({
            title: "Are you sure?",
            text: `Are you sure want to ${state?.data?.account_status !== "ACTIVATED" ? `activate` : `deactivate`} this seller!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, ${state?.data?.account_status !== "ACTIVATED" ? `activate` : `deactivate`} it!`,
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const data = {
                    type: "ACTIVATE/DEACTIVATE",
                    _id: state?.data?._id,
                    account_status: state?.data?.account_status == "ACTIVATED" ? `DEACTIVATED` : `ACTIVATED`,
                }
                try {
                    let apires = await henceforthApi.Seller.manageSeller(data)
                    toast.success(apires?.data?.message)
                    sellerdetails()
                } catch (error) {
                    handleError(error)
                } finally {
                    setloader1(false)
                }
            }
        })
    }
    const onChangeBlockUnblock = async () => {
        // Swal.fire({
        //     title: "Are you sure?",
        //     text: "Are you sure want to delete this seller!",
        //     icon: "warning",
        //     showCancelButton: true,
        //     confirmButtonColor: "#3085d6",
        //     cancelButtonColor: "#d33",
        //     confirmButtonText: "Yes, delete it!",
        // })
        // setloader(true)
        // const data = {
        //     type: "BLOCK/DELETE",
        //     _id: state?.data._id,
        //     is_blocked: state?.data.is_blocked == true ? false : true,
        //     // is_deleted: state?.data.is_deleted == true ? false : true,
        //     language: "ENGLISH"
        // }
        // try {
        //     let apires = await henceforthApi.Seller.manageSeller(data)
        //     toast.success(apires.data.message)
        //     sellerdetails()
        // } 
        // catch (error) {
        //     console.log(error)
        // } finally {
        //     setloader(false)
        // }
        Swal.fire({
            title: "Are you sure?",
            text: `Are you sure want to ${state?.data?.is_blocked !== true ? `block` : `unblock`} this seller!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: `Yes, ${state?.data?.is_blocked !== true ? `block` : `unblock`} it!`,
        }).then(async (result: any) => {
            if (result.isConfirmed) {
                const data = {
                    type: "BLOCK/DELETE",
                    _id: state?.data?._id,
                    is_blocked: state?.data?.is_blocked == true ? false : true,
                    // is_deleted: state?.data.is_deleted == true ? false : true,
                    language: "ENGLISH"
                }
                try {
                    let apires = await henceforthApi.Seller.manageSeller(data)
                    toast.success(apires?.data?.message)
                    sellerdetails()
                } catch (error) {
                    handleError(error)
                } finally {
                    setloader1(false)
                }
            }
        })
    }
    useEffect(() => {
        sellerdetails()
    }, [])

    return (
        <Fragment>
            {/* breadcrum  */}
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            {/* title  */}
                            <h2 className="fw-semibold">View Seller</h2>
                            {/* breadcrum  */}
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                    <li className="breadcrumb-item"><Link to="/sellers/1">Seller List</Link></li>
                                    <li className="breadcrumb-item active fw-bold">View Seller</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            {/* page  */}
            <div className='page-spacing'>
                <section className='change-password'>
                    <div className="container-fluid">
                        <div className="row gy-3 justify-content-center">
                            <div className="col-sm-12 col-md-7 col-lg-6 col-xl-5 col-xxl-3 px-xs-0">
                                {/* Profile Card  */}
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>View Seller</h5>
                                    </div>
                                    {/* Profile  */}
                                    <div className="common-card-content">
                                        {/* Profile image  */}
                                        <div className="profile-image">
                                            <SignedImage
                                                src={state?.data?.image || ""}
                                                fallback={profile_placeholder}
                                                className='img-fluid'
                                                size="small"
                                            />
                                        </div>
                                        {/* Profile Detail  */}
                                        <div className="profile-image my-4">
                                            <h5 className='mb-3'>{state?.data?.name}</h5>
                                            <p className="d-flex align-items-center mb-1"><i className='fa fa-envelope me-2 fs-5'></i>{state?.data?.email}</p>
                                            <p className="d-flex align-items-center mb-1"><i className='fa fa-phone-square me-2 fs-5'></i>+91 {state?.data?.phone_number}</p>
                                            <p className="d-flex align-items-start"><i className='fa fa-map-marker me-2 fs-5 mt-1'></i>{state?.data?.full_address}</p>
                                        </div>
                                        {/* button  */}
                                        <div className="profile-button">
                                            <ul className='list-unstyled d-flex gap-2  flex-wrap'>
                                                <li className='w-100'>
                                                    <a href={`${Redirect_Seller_URL}login-with-user/${state?.data?._id}/${authState?.access_token}`} target="_blank">
                                                        <button type='button' className='btn btn-theme w-100'><i className='fa fa-sign-in me-1'></i> Login as seller</button>
                                                    </a>
                                                </li>
                                                <li className='w-100'><button type='button' className='btn btn-white w-100 bg-danger text-white' onClick={onChnageDelete} disabled={loading}><i className='fa fa-trash me-1'></i>{loading ? <Spinner /> : "Delete"}</button></li>
                                                <li className='w-100'>
                                                    <button type='button' className='btn btn-white bg-black text-white w-100' onClick={onChangeActiveDeactive} disabled={loader1}>
                                                        {state?.data?.account_status == "ACTIVATED" ? <span> {loader1 ? <Spinner /> : <><i className='fa fa-toggle-on me-1'></i> Deactivate</>}</span> :
                                                            <span>{loader1 ? <Spinner /> : <><i className='fa fa-toggle-off me-1'></i>Activate</>}</span>}
                                                    </button >
                                                </li>

                                                <li className='w-100'>
                                                    <button type='button' className='btn btn-white bg-dark text-white w-100' onClick={onChangeBlockUnblock} disabled={loader}>
                                                        {state?.data?.is_blocked == false ?
                                                            <span>{loader ? <Spinner /> : <><i className='fa fa-ban me-1'></i>Block</>}</span> :
                                                            <span>{loader ? <Spinner /> : <><i className='fa fa-ban me-1'></i>Unblock</>}</span>}
                                                    </button>

                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>




                            {/************************************** Commission Management  *************************************/}
                            {state && state?.data?.role !== "store" && <div className="col-sm-12 col-md-7 col-lg-6 col-xl-5 col-xxl-3 px-xs-0">
                                <div className="common-card">
                                    <div className="common-card-title">
                                        <h5>Seller Commission</h5>
                                    </div>
                                    <div className="common-card-content">
                                        {currentCommission !== null && (
                                            <div className="mb-3">
                                                <p className="text-muted mb-1">Current Commission:</p>
                                                <p className="fw-semibold fs-5">{currentCommission}%</p>
                                            </div>
                                        )}
                                        <form onSubmit={handleCommissionSubmit}>
                                            <div className="mb-3">
                                                <label className="form-label">Commission (%)</label>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={commission}
                                                    onChange={(e) => setCommission(e.target.value)}
                                                    placeholder="Enter commission percentage"
                                                    min="0"
                                                    max="100"
                                                    step="0.01"
                                                    required
                                                />
                                            </div>
                                            <button
                                                type="submit"
                                                className="btn btn-theme w-100"
                                                disabled={commissionLoading}
                                            >
                                                {commissionLoading ? <Spinner /> : <><i className='fa fa-save me-1'></i> Save Commission</>}
                                            </button>
                                        </form>
                                    </div>
                                </div>
                            </div>}



                            {/************************************** Product Order details  *************************************/}
                            <div className="col-xxl-9 px-xs-0">
                                {/************************************** Product list details  *************************************/}
                                <div className='product-detail-box mb-3'>
                                    <ProductListingDetails id={(match?.params?.id)} />
                                </div>

                                {/************************************** order detail  *************************************/}
                                <SellerOrderListing id={(match?.params?.id)} />

                                {state && state?.data?.role !== "store" && (
                                    <div className="col-12 px-xs-0 mt-4">
                                        <StoreList masterSellerId={state?.data?._id} />
                                    </div>
                                )}
                            </div>

                            {/************************************** Seller Documents Section  *************************************/}
                            {state?.data?.documents && state?.data?.documents.length > 0 && (
                                <div className="col-12 px-xs-0 mt-4">
                                    <div className="common-card">
                                        <div className="common-card-title">
                                            <h5>Seller Verification Documents</h5>
                                        </div>
                                        <div className="common-card-content">
                                            <div className="row gy-4">
                                                {state?.data?.documents?.map((doc: any, index: number) => (
                                                    <div key={index} className="col-md-6 col-xl-3">
                                                        <div className="document-card h-100 border rounded-3 overflow-hidden shadow-sm">
                                                            <div className="document-card-header bg-theme-light-color bg-opacity-10 p-3 border-bottom">
                                                                <h6 className="fw-bold mb-0 text-theme text-uppercase small">
                                                                    {doc?.type?.replace('_', ' ')}
                                                                </h6>
                                                            </div>
                                                            <div className="document-card-body p-3">
                                                                <div className="document-images row g-2">
                                                                    {doc?.images?.front && (
                                                                        <div className="col-6">
                                                                            <div
                                                                                className="document-image-wrapper position-relative overflow-hidden rounded border"
                                                                                onClick={() => setSelectedImage(doc?.images?.front)}
                                                                                role="button"
                                                                                title="Click to view full image"
                                                                            >
                                                                                <SignedImage
                                                                                    src={doc?.images?.front || ""}
                                                                                    fallback={profile_placeholder}
                                                                                    alt={`${doc?.type} front`}
                                                                                    className='img-fluid w-100'
                                                                                    style={{ height: '160px', objectFit: 'cover', cursor: 'pointer', transition: 'transform 0.3s' }}
                                                                                    size="medium"
                                                                                />
                                                                                <div className="document-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                                                    style={{ background: 'rgba(0,0,0,0.5)', opacity: 0, transition: 'opacity 0.3s' }}>
                                                                                    <i className='fa fa-search-plus text-white fa-2x'></i>
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-center mt-2">
                                                                                <small className="text-muted">Front</small>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {doc?.images?.back && (
                                                                        <div className="col-6">
                                                                            <div
                                                                                className="document-image-wrapper position-relative overflow-hidden rounded border"
                                                                                onClick={() => setSelectedImage(doc?.images?.back)}
                                                                                role="button"
                                                                                title="Click to view full image"
                                                                            >
                                                                                <SignedImage
                                                                                    src={doc?.images?.back || ""}
                                                                                    fallback={profile_placeholder}
                                                                                    alt={`${doc?.type} back`}
                                                                                    className='img-fluid w-100'
                                                                                    style={{ height: '160px', objectFit: 'cover', cursor: 'pointer', transition: 'transform 0.3s' }}
                                                                                    size="medium"
                                                                                />
                                                                                <div className="document-overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                                                                                    style={{ background: 'rgba(0,0,0,0.5)', opacity: 0, transition: 'opacity 0.3s' }}>
                                                                                    <i className='fa fa-search-plus text-white fa-2x'></i>
                                                                                </div>
                                                                            </div>
                                                                            <div className="text-center mt-2">
                                                                                <small className="text-muted">Back</small>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>
                </section>
            </div >

            {/************************************** Image Modal  *************************************/}
            {selectedImage && (
                <div
                    className="document-modal-overlay"
                    onClick={() => setSelectedImage(null)}
                    style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.9)',
                        zIndex: 9999,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        animation: 'fadeIn 0.3s ease'
                    }}
                >
                    <div
                        className="document-modal-content"
                        onClick={(e) => e.stopPropagation()}
                        style={{
                            position: 'relative',
                            maxWidth: '90%',
                            maxHeight: '90vh',
                            animation: 'zoomIn 0.3s ease'
                        }}
                    >
                        <button
                            className="document-modal-close"
                            onClick={() => setSelectedImage(null)}
                            style={{
                                position: 'absolute',
                                top: '-40px',
                                right: '0',
                                background: 'white',
                                border: 'none',
                                borderRadius: '50%',
                                width: '40px',
                                height: '40px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                cursor: 'pointer',
                                fontSize: '20px',
                                fontWeight: 'bold',
                                color: '#333',
                                boxShadow: '0 2px 10px rgba(0,0,0,0.3)',
                                zIndex: 10000,
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'rotate(90deg) scale(1.1)';
                                e.currentTarget.style.backgroundColor = '#f8f9fa';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'rotate(0deg) scale(1)';
                                e.currentTarget.style.backgroundColor = 'white';
                            }}
                        >
                            <i className='fa fa-times'></i>
                        </button>
                        <SignedImage
                            src={selectedImage || ""}
                            fallback={profile_placeholder}
                            alt="Document Full View"
                            className='img-fluid'
                            style={{

                                width: '90vw',
                                height: '90vh',
                                maxWidth: '90vw',
                                maxHeight: '90vh',
                                objectFit: 'contain',
                                borderRadius: '8px',
                                boxShadow: '0 10px 40px rgba(0,0,0,0.5)'
                            }}
                            size="original"
                        />

                    </div>
                </div>
            )}
        </Fragment>
    )
}
export default ViewSeller;